var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"fundraising"},[_vm._m(0),_c('add-fundraising',{on:{"alertUser":(result, message) => {this.$emit('alertUser', result, message);}}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageHeading"},[_c('h1',[_vm._v("Apply Fundraising")])])
}]

export { render, staticRenderFns }